<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ArrowIcon from "@apps/reviews/components/icons/ArrowIcon.svelte";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import Spinner from "@components/Spinner/Spinner.svelte";

    export let hasNext = true;
    export let hasPrev = true;
    export let status: STATUS;

    const dispatch = createEventDispatcher();
    const handleNextSlide = (): void => {
        dispatch("nextSlide");
    };
    const handlePrevSlide = (): void => {
        dispatch("prevSlide");
    };
</script>

<div class="gw-rv-reviews-images-arrows">
    {#if hasPrev}
        <BaseButton
            ariaLabel="Previous review slides"
            class="gw-rv-reviews-images-arrows__arrow gw-rv-reviews-images-arrows__arrow--prev"
            on:click={handlePrevSlide}
        >
            <Icon width={24} height={24}>
                <ArrowIcon />
            </Icon>
        </BaseButton>
    {/if}
    {#if hasNext}
        <BaseButton
            ariaLabel="Next reviews slides"
            class="gw-rv-reviews-images-arrows__arrow gw-rv-reviews-images-arrows__arrow--next"
            on:click={handleNextSlide}
            disabled={status === STATUS.LOADING}
            aria-disabled={status === STATUS.LOADING}
        >
            {#if status === STATUS.LOADING}
                <Spinner />
            {:else}
                <Icon width={24} height={24}>
                    <ArrowIcon />
                </Icon>
            {/if}
        </BaseButton>
    {/if}
</div>

<style lang="postcss" global>
    .gw-rv-reviews-images-arrows {
        &__arrow {
            width: 42px;
            height: 42px;
            position: absolute;
            top: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: translateY(-50%);
            background-color: rgba(199, 198, 198, 0.6);
            color: #1d2939;
            border-radius: 38px;
            z-index: 10;

            &--prev {
                left: 0;
                transform: translateY(-50%) rotateZ(180deg);
            }

            &--next {
                right: 0;
            }

            &:hover {
                opacity: 1;
            }
        }

        @media screen and (max-width: 425px) {
            &__arrow {
                width: 2.5em;
                height: 2.5em;
                align-items: center;
            }
        }
    }
</style>
